import { observer } from 'mobx-react-lite';
import React, { useContext, useEffect } from 'react';
import { Button, Grid } from 'semantic-ui-react';

import LoadingComponent from '../../../app/layout/LoadingComponent';
import { RootStoreContext } from '../../../app/stores/rootStore';
import DepositSalesTicketFilters from './DepositSalesTicketFilters';
import DepositSalesTicketList from './DepositSalesTicketList';

const DepositSalesTicketDashboard: React.FC = () => {
  const rootStore = useContext(RootStoreContext);
  const { loadAgents } = rootStore.agentStore;
  const {
    loading,
    searchMode,
    loadDepositSalesTicketAttributes,
    setSearchMode,
  } = rootStore.depositSalesTicketStore;

  useEffect(() => {
    loadAgents();
    loadDepositSalesTicketAttributes();
  }, [loadAgents, loadDepositSalesTicketAttributes]);

  if (loading) return <LoadingComponent content='Loading...' />;

  return (
    <Grid>
      <Grid.Column width={16}>
        <Button
          content='検索条件'
          icon={searchMode ? 'angle up' : 'angle down'}
          onClick={() => setSearchMode(!searchMode)}
        />
        {searchMode && <DepositSalesTicketFilters />}
        <DepositSalesTicketList />
      </Grid.Column>
    </Grid>
  );
};

export default observer(DepositSalesTicketDashboard);
